import { render, staticRenderFns } from "./factory_item_info.vue?vue&type=template&id=daebcfb8"
import script from "./factory_item_info.vue?vue&type=script&lang=js"
export * from "./factory_item_info.vue?vue&type=script&lang=js"
import style0 from "./factory_item_info.vue?vue&type=style&index=0&id=daebcfb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports